module.exports = __webpack_public_path__ + "static/img/1057_big.6e97031.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1057_big.png
// module id = sCL4
// module chunks = 1